import { CSSProperties } from "react";
import { getDataObjArray } from "../Sidebar/SideBarUtils";

export function handleValueDataAudienceIndice(
  valueData: string,
  sufix: string
) {
  let resultValue = "";
  if (valueData !== null && valueData !== undefined) {
    if (valueData === "-") return valueData;
    resultValue = valueData;
    const valueIsDoubleIndice = resultValue.indexOf("|") >= 0;
    resultValue = AdjustValueDataAudienceIndiceNaNOrInfinity(valueData);
    resultValue = AdjustValueDataAudienceIndiceNotNaNOrInfinity(
      resultValue,
      sufix,
      valueIsDoubleIndice
    );
    resultValue = AdjustValueDataAudienceIndiceDoubleEmpyt(
      resultValue,
      valueIsDoubleIndice
    );
  }
  resultValue = resultValue === "Infinity" ? "∞" : resultValue;
  return resultValue;
}
export function AdjustValueDataAudienceIndiceNaNOrInfinity(valueData) {
  let resultValue = valueData;
  if (resultValue.indexOf("NaN") >= 0 || resultValue.indexOf("Infinity") >= 0) {
    resultValue = resultValue.replace("%", "");
  }
  return resultValue;
}
export function AdjustValueDataAudienceIndiceNotNaNOrInfinity(
  valueData,
  sufix: string,
  valueIsDoubleIndice: boolean
) {
  let resultValue = valueData;
  if (
    resultValue !== "NaN" &&
    resultValue !== "Infinity" &&
    resultValue !== " " &&
    !valueIsDoubleIndice
  ) {
    resultValue += sufix;
  }
  return resultValue;
}

export function AdjustValueDataAudienceIndiceDoubleEmpyt(
  valueData,
  valueIsDoubleIndice: boolean
) {
  let resultValue = valueData;
  if (valueIsDoubleIndice) {
    const splitVal = valueData.split("|");
    if (
      (splitVal[0].trim() === "" && splitVal[1].trim() === "") ||
      resultValue === "-|-"
    ) {
      resultValue = "";
    }
  }
  return resultValue;
}

export function renderTableFirstGrid(row: any, rowContent, Target) {
  if (rowContent[2] == "" || rowContent[3] == 0) {
    return getDataObjArray(row).map((val, rowID) =>
      renderTableFirstGridRowContent2EmptyAndEqual1(val, rowID, Target)
    );
  } else {
    return getDataObjArray(row).map((val, rowID) =>
      renderTableFirstGridEqual1or2(val, rowID, Target)
    );
  }
}

export function renderTableFirstGridRowContent2EmptyAndEqual1(val, rowID, Target) {
  let iconClass = "header-icon-" + Target;
  if (rowID === 1) {
    return (
      <td
        key={val.ValueId}>
        <span style={{
          color: "#c9a404",
          fontSize: "14px",
          marginRight: "5px",
        }}>
          <i className="header-icon-13"></i>
        </span>
        <span style={{ fontSize: "15px" }}>
          {val.DataValueArray}
        </span>
      </td>
    );
  }
  if (rowID === 2 && val.DataValueArray !== "")
    return (
      <td
        key={val.ValueId}>
        <span style={{
          color: "#c9a404",
          marginRight: "3px",
        }}>
          <i className={iconClass}
          ></i>
        </span>
        <span style={{ fontSize: "15px" }}>
          {val.DataValueArray}
        </span>
      </td>
    );
    else if (rowID === 2 && val.DataValueArray === "")
      return (
        <td
          key={val.ValueId}
          style={{
            borderRight: '1px solid #FFF'
          }}>
          <span style={{
            color: "#c9a404",
            marginRight: "3px",
          }}>
          
          </span>
          <span style={{ fontSize: "15px" }}>
            {val.DataValueArray}
          </span>
        </td>
      );
  

  return <></>;
}
export function renderTableFirstGridEqual1or2(rowVal: any, rowID, Target) {
  if (rowID === 1)
    return (
      <td style={{ color: "white", textAlign: "center", fontSize: "17px" }} key={rowVal.ValueId}>
        {rowVal.DataValueArray}
      </td>
    );

  if (rowID === 2 && rowVal.DataValueArray !== "")
    return (
      <td className="tableFirstGrid">
        <p style={{ margin: "0px",fontSize: "15px" }}>
          <i
            className={"header-icon-" + Target}
            style={{ fontSize: "11px", marginRight: "1px" }}
          ></i>
          <span style={{ color: "white" }}>{rowVal.DataValueArray}</span>
        </p>
      </td>
    );
  
  return <></>;
}
export function getCSSPropertiesHeight(
  userPreferenceTipoBase: number,
  Indice: number
) {
  const resultCss: CSSProperties = {
    height: userPreferenceTipoBase === 0 && Indice <= 2 ? "30px" : "64px",
    minHeight: userPreferenceTipoBase === 0 && Indice <= 2 ? "30px" : "64px",
  };
  return resultCss;
}
export function getStyleByIndice(Indice: any): CSSProperties | undefined {
  if (Indice > 2) {
    return { height: "48px" };
  }
}
export function getClassNameByIndice(Indice: any): string {
  if (Indice > 2) {
    return "dobleIndice";
  }
  return "";
}
export function handleValueDataEmpytAudienceIndice(
  valueData: string,
  sufix: string
) {
  if (valueData === "-" || valueData === "Infinity" || valueData === "NaN") return valueData;

  return valueData + sufix;
}